const html = require('choo/html');

module.exports = component;
/*
    <p class="ma0 pa0 f6">
      <b>Location:</b> ${state['town/city']}, ${state['state/territory']}
    </p>
    <p class="ma0 pa0 f6"><b>Facility Type:</b> ${state.type_of_facility}</p>
    <p class="ma0 pa0 f6">
      <b>Production Capacity:</b> ${state.production_capacity}
    </p>
*/
function component(state, closeHandler) {
    return html `<div
    class="absolute top-0 right-1 bg-black o-70 pl2 pr1 pt2 pb2 pa3-ns z-999 w-50 w-third-ns mt3 white content-container"
  >
    <div class="o-100">
      <div class="flex items-start justify-between">
        <p class="mt0 mb3-ns mb1 pa0 TIMonoExBold ttu w-two-thirds dib lg-info">
          ${state.owner}
        </p>
        <img
          class="dib"
          style="cursor: pointer;"
          onclick=${closeHandler}
          src="assets/close.svg"
        />
      </div>
      <p class="mb2-ns mb1 mt0 pa0 TIMonoExBold md-info">
        <div class="sm-info">average ethylene oxide emissions ${
          state.emissions_date_range
        }</div>  
        ${state['tri_avg_reported_2014_2019'].toLocaleString()} lbs.
      </p>
      <div class="TIMono absolute bottom-2-ns bottom-3 sm-info">
        ${
          state['tri_revision_amount'] !== 0
            ? html`<div>
                <p class="mh0 mt0 mb1 mb2-ns pa0">
                  ${state.estimated_revisions ? 'estimated' : ''} amount of
                  revision:
                </p>
                <p class="ma0 pa0">
                  ${state['tri_revision_amount'].toLocaleString()} lbs.
                </p>
              </div>`
            : ''
        }
        

        <p class="mt3-ns mt2 mb0 pa0">community alerted by EPA:</p>
        <p class="ma0 pa0">${state.epa_outreach_conducted ? 'Yes' : 'No'}</p>
        ${
          state.tri_facility_id === '60085CSMDF1160N'
            ? html`<p class="mt1 pa0 mb0 mh0 f7">
                Source: EPA National Emissions Inventory
              </p>`
            : ''
        }
        
      </div>
    </div>
  </div>`;
}